import styled from "@emotion/styled/macro";
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';

export const UserMenuContainer = styled.div`
display: flex;
align-items: center;
`;

export const StyledTitle = styled(Typography)`
font-size: 20px;
font-weight: 500;
line-height: 1.88;
letter-spacing: 0.06em;
margin-right: 20px;
`;


export const StyledIconButton = styled(IconButton)`
color: #ffffff;
`;
